export default {"src":"/_next/static/media/Existing-user.330f4025.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};